import { AxiosError, AxiosResponse } from "axios";
import { store } from "@/store/store";
import { setAccessToken, setRefreshToken } from "@/store/user/slice";
import { client } from '../client';

export const setupAuthInterceptor = () => {
  client.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error: AxiosError) => {
      const originalRequest = error.config;

      // @ts-expect-error _retry is our own custom property
      if (originalRequest && error.response?.status === 401 && !originalRequest._retry) {

        // @ts-expect-error _retry is our own custom property
        originalRequest._retry = true;

        try {
          const rawRefresh = localStorage.getItem('refreshToken');
          const refreshToken = (!rawRefresh || rawRefresh === 'null')
            ? null
            : (() => { try { return JSON.parse(rawRefresh)?.token ?? null; } catch { return null; } })();

          if (!refreshToken) {
            // Don't hard reload here as it disrupt the error response.
            return Promise.reject(error);
          }

          const { data } = await client.post('/auth/refresh-tokens', { refreshToken });

          localStorage.setItem('accessToken', JSON.stringify(data.access));
          localStorage.setItem('refreshToken', JSON.stringify(data.refresh));

          store.dispatch(setAccessToken(data.access));
          store.dispatch(setRefreshToken(data.refresh));

          originalRequest.headers.Authorization = `Bearer ${data.access.token}`;
          return client(originalRequest);
        } catch {
          return Promise.reject(error);
        }
      }
      return Promise.reject(error);
    }
  );
};